import React, { useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import bgPayment from 'assets/images/icons/campaign-data-collection/bg-payment.jpg';
import { CampaignContainer } from 'pages/admin/campaign-overview/campaign-container';
import paymentSuccessful from 'assets/images/icons/campaign-data-collection/payment-successful.png';
import paymentFailed from 'assets/images/icons/campaign-data-collection/payment-failed.png';
import { useAppDispatch, useAppSelector } from 'common/hook';
import { RootState } from 'plugins/store';
import { resetSurveyPayment } from 'slices/paymentSlice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CampaignConstants from 'pages/admin/campaign/constants';
// call payment api success or failure
const PaymentResults = () => {
    const listBackgroundImage = [bgPayment];
    const currentCampaign = useAppSelector(
        (state: RootState) => state.campaignState.campaign
    );
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const transactionStatus = searchParams.get('vnp_TransactionStatus');

    useEffect(() => {
        if (!currentCampaign) return;
        if (
            currentCampaign?.status_client !==
                CampaignConstants.status.CLIENT_DRAFT &&
            transactionStatus === '00'
        ) {
            return;
        }
    }, [currentCampaign, navigate, transactionStatus]);
    return (
        <CampaignContainer>
            <Box
                sx={{
                    height: '387px',
                    borderRadius: '30px',
                    backgroundImage: `url(${listBackgroundImage[0]})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    padding: '135px 145px',
                    marginBottom: '16px',
                }}
            >
                <Typography
                    variant="h3"
                    sx={{
                        fontSize: '80px',
                        fontWeight: 700,
                        lineHeight: '96px',
                        color: (theme) => theme.palette.common.white,
                    }}
                >
                    Thanh toán dịch vụ
                </Typography>
            </Box>
            <Typography
                variant="h3"
                sx={{
                    fontSize: '50px',
                    fontWeight: 600,
                    lineHeight: '60px',
                    marginBottom: '34px',
                }}
            >
                {currentCampaign?.campaign}
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    fontSize: '28px',
                    lineHeight: '40px',
                    fontWeight: 400,
                    marginBottom: '72px',
                }}
            >
                Hoàn tất việc thanh toán này, hệ thống sẽ tự động chọn lựa các
                ứng viên phù hợp nhất với yêu cầu đối tượng và lần lượt gửi bằng
                khảo sát của bạn đến những đáp viên này qua SMS.
                <Typography
                    component={'a'}
                    sx={{
                        color: '#0088FF',
                        textDecoration: 'none',
                        fontSize: '28px',
                    }}
                    href="#"
                >
                    Tìm hiểu thêm về cách chống gian lận.
                </Typography>
            </Typography>
            {currentCampaign && (
                <Box sx={{ textAlign: 'center' }}>
                    {(currentCampaign.paymentStatus.status === 'paid' ||
                        transactionStatus === '00') && (
                        <>
                            <img
                                src={paymentSuccessful}
                                alt="payment"
                                style={{
                                    width: '20%',
                                    marginBottom: '24px',
                                }}
                            />
                            <Typography
                                sx={{
                                    fontSize: '32px',
                                    fontWeight: 600,
                                    color: 'primary.main',
                                    marginBottom: '24px',
                                }}
                            >
                                Thanh toán thành công
                            </Typography>
                            {!currentCampaign.paymentStatus.email && (
                                <Typography
                                    sx={{
                                        marginBottom: '24px',
                                    }}
                                >
                                    Mã đơn hàng:{' '}
                                    <Box
                                        component={'span'}
                                        sx={{
                                            fontWeight: 700,
                                            color: 'primary.main',
                                        }}
                                    >
                                        {currentCampaign.paymentStatus.order_id}
                                    </Box>
                                </Typography>
                            )}

                            {currentCampaign.paymentStatus.email && (
                                <Typography
                                    sx={{
                                        marginBottom: '24px',
                                    }}
                                >
                                    Chi tiết đơn hàng “
                                    <Box
                                        component={'span'}
                                        sx={{
                                            fontWeight: 700,
                                            color: 'primary.main',
                                        }}
                                    >
                                        {currentCampaign.paymentStatus.order_id}
                                    </Box>
                                    ” đã được gửi vào email{' '}
                                    <Box
                                        component={'span'}
                                        sx={{
                                            fontWeight: 700,
                                            color: 'primary.main',
                                        }}
                                    >
                                        {currentCampaign.paymentStatus.email}
                                    </Box>
                                    của bạn. Vui lòng truy cập vào email để xem
                                    chi tiết.
                                </Typography>
                            )}
                        </>
                    )}
                    {(currentCampaign.paymentStatus.status === 'failed' ||
                        (transactionStatus && transactionStatus !== '00')) && (
                        <>
                            <img
                                src={paymentFailed}
                                alt="payment"
                                style={{
                                    width: '20%',
                                    marginBottom: '24px',
                                }}
                            />
                            <Typography
                                sx={{
                                    fontSize: '32px',
                                    fontWeight: 600,
                                    color: 'primary.main',
                                    marginBottom: '24px',
                                }}
                            >
                                Thanh toán không thành công
                            </Typography>
                            {!currentCampaign.paymentStatus.email && (
                                <Typography
                                    sx={{
                                        marginBottom: '24px',
                                    }}
                                >
                                    Mã đơn hàng:{' '}
                                    <Box
                                        component={'span'}
                                        sx={{
                                            fontWeight: 700,
                                            color: 'primary.main',
                                        }}
                                    >
                                        {currentCampaign.paymentStatus.order_id}
                                    </Box>
                                </Typography>
                            )}

                            {currentCampaign.paymentStatus.email && (
                                <Typography
                                    sx={{
                                        marginBottom: '24px',
                                    }}
                                >
                                    Chi tiết đơn hàng “
                                    <Box
                                        component={'span'}
                                        sx={{
                                            fontWeight: 700,
                                            color: 'primary.main',
                                        }}
                                    >
                                        {currentCampaign.paymentStatus.order_id}
                                    </Box>
                                    ” đã được gửi vào email{' '}
                                    <Box
                                        component={'span'}
                                        sx={{
                                            fontWeight: 700,
                                            color: 'primary.main',
                                        }}
                                    >
                                        {currentCampaign.paymentStatus.email}
                                    </Box>
                                    của bạn. Vui lòng truy cập vào email để xem
                                    chi tiết.
                                </Typography>
                            )}
                        </>
                    )}
                    {currentCampaign.paymentStatus.status === 'pending' && (
                        <>
                            <Typography
                                variant="h3"
                                sx={{
                                    fontSize: '45px',
                                    fontWeight: 600,
                                    lineHeight: '54.46px',
                                    color: (theme) => theme.palette.info.main,
                                }}
                            >
                                Khảo sát đang chờ thanh toán dịch vụ
                            </Typography>
                            <Typography sx={{ marginBottom: '34px' }}>
                                Sau khi thanh toán thành công, vui lòng ấn nút
                                &quot;Quay lại khảo sát&quot;
                            </Typography>
                            <Box mx={'auto'}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        width: '100%',
                                        marginBottom: '39px',
                                        minHeight: '60px',
                                        borderRadius: '60px',
                                        fontSize: '24px',
                                        textTransform: 'none',
                                        fontWeight: 700,
                                    }}
                                    onClick={() => {
                                        // open link currentCampaign.url_payment in new tab
                                        window.open(
                                            currentCampaign.paymentStatus
                                                .url_payment,
                                            '_blank'
                                        );
                                    }}
                                >
                                    Thanh toán
                                </Button>
                            </Box>
                        </>
                    )}

                    <Button
                        variant="contained"
                        sx={{
                            width: '100%',
                            marginBottom: '60px',
                            minHeight: '60px',
                            borderRadius: '60px',
                            fontSize: '24px',
                            textTransform: 'none',
                            fontWeight: 700,
                            backgroundColor: '#FF7916',
                            '&:hover': {
                                backgroundColor: '#FF7916',
                            },
                        }}
                        onClick={() => {
                            dispatch(resetSurveyPayment());
                            navigate(
                                `/admin/campaign/data-collect/${currentCampaign?.id}`
                            );
                        }}
                    >
                        Quay lại khảo sát
                    </Button>
                </Box>
            )}
        </CampaignContainer>
    );
};

export default PaymentResults;
